import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ChangePassword } from "../../pages/Auth/ChangePassword";

export function ChangePasswordModal(props) {
  const { isOpen, toggleModal } = props;

  return (
    <Modal show={isOpen} onHide={() => toggleModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Change Password
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ChangePassword toggle={() => toggleModal(false)} />
      </Modal.Body>
    </Modal>
  );
}
